<template>
    <div class="tab-list">
        <div v-for="(item,index) in tabList" 
        :key="index" 
        :class="['tab-item', curIndex == index ? 'active' : '']" 
        @click="to(item.url)">
            {{item.name}}
        </div>
    </div>
</template>

<script>
    export default {
        props: {
        	curIndex: {
        		type: Number,
        		default: 0
        	}
        },
        data() {
            return {
                tabList: [
                    {name: this.$t('Account.PersonalCenter'), url: '/account'},
                    {name: this.$t('Account.LoginHistory'), url: '/account/LoginHistory'}
                ]
            }
        },
        methods: {
            to(path) {
                this.$router.push({
                    path
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    .tab-list {
        min-width: $nav-width;
        max-width: $nav-width;
        margin-right: 25px;
        
        .tab-item {
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100%;
            box-sizing: border-box;
            padding: 20px 24px;
            font-size: 15px;
            color: #000000;
            word-wrap: break-word;
            background-color: #FFFFFF;
            cursor: pointer;
        }
        
        .active {
            color: #5466EF;
            background-color: #F4F5F9;
        }
    }
</style>